import React from "react";
import moneyFormatter from "money-formatter";
import "./valueStatement.scss";

const ValueStatement = ({ firstName, loanAmount }) => {
  return (
    <div id="combo-app-value-statement" className="combo-app-value-statement background-section">
      <div className="px-4 py-2">
        <h2 className="headline-font">
          <div className="pb-2">
            Congratulations, <span className="font-weight-normal">{firstName}</span>!
          </div>
          <div>
            You’re <span className="font-weight-normal">pre-qualified</span> for a loan
            up to <span className="font-weight-normal">{moneyFormatter.format('USD', loanAmount, 0)}.</span>
          </div>
        </h2>
        <p className="pt-2 subheadline-font">Barclays offers its personal loans
                with <span className="font-weight-normal">absolutely NO fees.</span></p>
      </div>
    </div>
  );
};

export default ValueStatement;
